import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'NexaTextDemo, Arial, sans-serif',
        fontVariantLigatures: 'none',
        body1: {
            fontFamily: 'NexaTextExtraLight, Arial, sans-serif',
            fontSize: '23px',
            lineHeight: 1.2,
            fontVariantLigatures: 'none'
        },
        h2: {
            fontFamily: 'HelveticaNeueBlack, Arial, sans-serif',
            fontWeight: 500,
            color: "#FF7911",
            fontSize: "25px",
            letterSpacing: 2,
            fontVariantLigatures: 'none'
        },
        h3: {
            fontFamily: 'NexaTextBold, Arial, sans-serif',
            fontWeight: 500,
            fontSize: "35px",
            letterSpacing: 1,
            lineHeight: 1.2,
            fontVariantLigatures: 'none'
        },
    },
});

export default theme;
